export default {
  name: 'marking--eanInputUpload',
  apiService: 'shoes',
  apiPath: '/admin/ean_input/func/upload',
  urlParamName: 'marking--eanInputUpload',
};